import React from 'react';
import { Color, Variant } from '@prisjakt/ui-button/src/types';

import * as S from './styles';

type Props = {
  className?: string;
  color?: Color;
  count?: number | string;
  icon?: React.ReactElement;
  onToggle: () => void;
  title: string;
  truncate?: boolean;
  variant?: Variant;
  'data-test'?: string;
};

export default function ToggleButton({
  className,
  color = 'primary',
  count,
  icon,
  onToggle,
  title,
  truncate,
  variant = 'default',
  'data-test': dataTest,
}: Props) {
  return (
    <S.ToggleButton
      className={className}
      color={color}
      onClick={onToggle}
      icon={icon}
      variant={variant}
      shouldTruncate={Boolean(truncate)}
      data-test={dataTest}
    >
      <S.Title>{title}</S.Title>

      {count && count !== 0 ? (
        <S.AppliedFilterCount buttonColor={color} buttonVariant={variant}>
          {count}
        </S.AppliedFilterCount>
      ) : null}
    </S.ToggleButton>
  );
}
